import { Component, OnInit, Renderer2, Inject, ChangeDetectorRef, NgZone } from '@angular/core'; 
import { ActivatedRoute, Router } from "@angular/router" 
import { DOCUMENT } from '@angular/common';
import { AuthenticationService } from '@services/security';
import { LoaderService } from '@modules/loader';  
import _ from 'lodash'; 
import { ConfirmEmailRequestModel } from '@shared/security/confirm-email-request.model';
import { SecurityQuestionRequest } from '@shared/security/security-question-request.model';
import { ConfirmationService } from 'primeng/api';


@Component({
  selector: 'app-confirm-account',
  templateUrl: './confirm-account.component.html',
  styleUrls: ['./confirm-account.component.scss'] 
})
export class ConfirmAccountComponent implements OnInit  {  
    infoMessage:string;  
    userId:string;
    token:string;
    step:number = 1;
    page:string;
    isError:boolean=false;
    submitted:boolean=false; 
    isConfirmed:boolean=false;
    CryptedEmail:string; 
    responseModel: SecurityQuestionRequest;
    isSecurityQuestionValid : boolean;  

  isLoading: boolean;

    constructor(private authService: AuthenticationService,
        private router: Router,
        private route:ActivatedRoute, 
        private changeDedectionRef :ChangeDetectorRef,
        private loaderService: LoaderService, private renderer: Renderer2,
        @Inject(DOCUMENT) private _document,   private zone: NgZone,private confirmationService : ConfirmationService) {
        }

        
  ngOnInit() {   
    this.responseModel = new SecurityQuestionRequest();
    this.confirmAccout();
  }

  ngAfterContentChecked(): void {
    this.changeDedectionRef.detectChanges();
  }  

  confirmAccout(){ 
     this.token = this.route.snapshot.queryParams["token"];
    this.userId = this.route.snapshot.queryParams["userid"];
    if(_.isEmpty(this.token) || _.isEmpty(this.userId))
    this.redirectToLogin(); 
  }
 
 redirectToLogin(){
  this.router.navigate(['/login']);
 }

 redirectToCreatePassword(url : string){
  this.zone.runOutsideAngular(() => {
    window.location.href = url;
  }); 
 }

 _save(){   
  const request = new ConfirmEmailRequestModel();
  request.Token = this.token;
  request.UserId = this.userId;
  request.SecurityQuestion = this.responseModel;
  this.submitted = true;
  this.loaderService.showLoader();
  this.authService.ConfirmEmail(request).subscribe((response:any)=>{  
       if(response != null && response !== undefined && response.IsConfirmed)
       {
          this.isError = false;
          this.isConfirmed = response.IsConfirmed;
          this.CryptedEmail = response.CryptedEmail;
          this.step = 2;
       }          
       else
       { 
        this.isError = true;
        this.step = 1;
       } 
         this.isLoading = false;
      }); 
  this.loaderService.hideLoader(); 
}

save(){  
 this.submitted = true; 
 if(!this.isSecurityQuestionValid) return false;  
 this.confirmationService.confirm({
   message: `Voulez-vous vraiment enregistrer votre question secrète ?`,
   accept: () => {
     this.isLoading = true;
     this._save();
   }
 }); 
} 
}